import {
  computed,
  effect,
  inject,
  Injectable,
  signal,
} from '@angular/core';
import { ICotrahentInfoByGuidSource, IGenPaymentUrl, IGenPaymentUrlSource, IPolicies, policies, policiesSource } from '../utils/models';
import { ApiService } from 'src/app/core/api.service';
import { ListModel } from 'src/app/shared/components/list/models';
import { DatePipe } from '@angular/common';
import { ResponseStatus } from 'src/app/auth/utils/account';
import { finalize } from 'rxjs';
import { Statuses, StatusesClass } from '../utils/enum';
import { AlertService } from 'src/app/shared/services/alert.service';
import { TurnsTileService } from 'src/app/auth/data-access/turns-tile.service';


const basePath: string = 'smeclients';

@Injectable({
  providedIn: 'root',
})
export class SmsLinkService {
  private readonly apiService = inject(ApiService);
  readonly datePipe = inject(DatePipe);
  readonly alert = inject(AlertService);
  

  // private policies = signal<policiesSource | null>(null);
  #cotrahentSource =signal<ICotrahentInfoByGuidSource|null>(null)
  
  readonly policiesState =computed(()=>structuredClone(this.#cotrahentSource()?.data.policies))
  readonly clientState =computed(()=>structuredClone(this.#cotrahentSource()?.data.client))
  readonly responsiblePersonState =computed(()=>structuredClone(this.#cotrahentSource()?.data.responsiblePerson))
  readonly loadedState =computed(()=>this.#cotrahentSource()?.loaded)
  readonly isLoadingState =computed(()=>this.#cotrahentSource()?.isLoading)
  readonly isDebtState =computed(()=>this.#cotrahentSource()?.isDebt)

  private policiesConfig = signal<ListModel[] | null>(null);
  readonly policiesConfigState = computed(()=>structuredClone(this.policiesConfig()));

  #paymentUrl =signal<IGenPaymentUrlSource|null>(null)
  readonly paymentUrlState =computed(this.#paymentUrl)
  
  readonly urlLoadedState =computed(()=>this.#paymentUrl()?.loaded)
  readonly urlLoadingState =computed(()=>this.#paymentUrl()?.isLoading)

  constructor() {
    effect(
      () => {
        this.setPoliciesList();
      },
      { allowSignalWrites: true }
    );
  }

  
   getCotrahentInfoByGuid(guid: string) {

    return this.apiService
      .get(`${basePath}/GetCotrahentInfoByGuidNew`,{guid})
      .subscribe({
        next: (res) => {
          if (res.status !== ResponseStatus.Success) return;
          else {
                 this.#cotrahentSource.update((state) => ({
                 ...state,
                 data:{policies:res.policies.map((policies:IPolicies)=>{
                  return {
                    ...policies,
                       disabled:policies.checkBox,
                       cssClass:this.getDebtCssClass({orderId:policies.orderId} )
                  }
                }),client:res.client,
                   responsiblePerson:res.responsiblePerson,
              },
                   loaded: true,
                   isLoading: false,
                   success:res.isSuccess,
                   isDebt:!!res.policies.length,
            }));}
        },
        error: (err) => {console.error(err)},
    })};
  

  // getPolicies(params?: any) {
  //   this.policies.update((state) => ({
  //     ...state,
  //     loaded: true,
  //     isDebt: !!this.dummyPolicies.length,
  //     data: this.dummyPolicies,
  //   }));
  // }
  getDebtCssClass(policies: { orderId: number }): any {
  return {
    [StatusesClass.FirstPmtPayed]:policies.orderId===Statuses.FirstPmtShouldBePayed,
    [StatusesClass.Debt]:policies.orderId===Statuses.PolicyCallOfToday||policies.orderId===Statuses.PolicyCallOfIn3Dayes,
    [StatusesClass.GracePeriod]:policies.orderId===Statuses.GracePeriodExpiredToday,
    [StatusesClass.TobePayed]:policies.orderId===Statuses.TobePayedToday||policies.orderId===Statuses.TobePayedIn15dayes,
    [StatusesClass.Payed]:policies.orderId===Statuses.Payed
  };
}
    // [StatusesClass.Debt]: policies.debtDays <= -15,
    // [StatusesClass.GracePeriod]: policies.debtDays>=-14&& policies.debtDays <=-1,
    // [StatusesClass.TobePayed]: policies.debtDays >=0,

  generatePaymentUrl(params:IGenPaymentUrl){

    this.#paymentUrl.update((state)=>({
      ...state,
         isLoading:true
    }))
    return this.apiService
      .post(`${basePath}/GeneratePaymentUrl`,params)
      .pipe(
        finalize(()=>
          this.#paymentUrl.update((state)=>({
          ...state,
          isLoading:false
    }))))
      .subscribe({
        next: (url) => {
       if (url&&url.payUrl) {
       this.#paymentUrl.update((state)=>({
              ...state,
              data:url,
              isLoading:false,
              loaded:true,
              success:true
            }))
        window.location.href = url.payUrl
          }
          else {
               this.alert.notification({
        message: 'გადახდის გვერდზე გადამისამართებისას დაფიქსირდა შეცდომა',
        messageType: 'error',
      });
          }
        },
        error: (err) => {console.error(err)},
    })};



  setPoliciesList() {
    this.policiesConfig.update(
      (state) =>
        (state = [
          {
            label: '',
            getData: this.policiesState()?.map((x) => ''),
            key: '',
            checkBox: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.currentDebts),
            key: '',
            checkBox: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.policyCurency),
            key: '',
            checkBox: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.checkboxMessage),
            key: '',
            checkBox: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.messageText),
            key: '',
            checkBox: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.paymentDebtMessage),
            key: '',
            checkBox: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.debtInformation),
            key: '',
            checkBox: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.disabled),
            key: 'disabled',
            forBackOnly: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.policyId),
            key: 'policyId',
            forBackOnly: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.debtDays),
            key: 'debtDays',
            forBackOnly: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.allDebet),
            key: 'allDebet',
            forBackOnly: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.paidAmount),
            key: 'paidAmount',
            forBackOnly: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.orderId),
            key: 'orderId',
            forBackOnly: true,
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.debtInformation),
            key: 'debtInformation',
          },
          {
            label: '',
            getData:this.policiesState()?.map((x) =>
              x.paymentDate
                ? this.datePipe.transform(new Date(x.paymentDate), 'dd/MM/yyyy')
                : ''
            ),
            key: 'paymentDate',
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.currentDebtsGEL),
            key: 'currentDebtsGEL',
          },
          {
            label: '',
            getData: this.policiesState()?.map((x) => x.checkBox),
            key: 'checkBox',
            forBackOnly: true,
          },
        ])
    );
  }

  // dummyPolicies: policies[] = [
  //   {
  //     coverage: 'Comprehensive',
  //     coverageArea: 'Europe',
  //     currency: 'USD',
  //     email: 'john.doe@example.com',
  //     franchise: 'Standard',
  //     fromDate: '2025-06-01',
  //     id: 1,
  //     insurerFullName: 'ABC Insurance Ltd.',
  //     insurerFullNameEng: 'ABC Insurance Ltd.',
  //     insurerPn: '123456789',
  //     isMultiPolicy: false,
  //     limit: 50000,
  //     phoneNumber: '+1234567890',
  //     policyNumber: 'K/PR/R/D/120622/24',
  //     policyType: 'Travel',
  //     policyUrl: 'https://example.com/policies/1',
  //     policyWordingUrl: 'https://example.com/wording/1',
  //     premium: 250,
  //     productType: 1,
  //     toDate: '2025-06-30',
  //     travelerFullName: 'John Doe',
  //     travelerFullNameEng: 'John Doe',
  //     travelerPn: '987654321',
  //     wordingName: 'Standard Travel Policy',
  //     currentDebt: 0,
  //     insuredName: 'John Doe',
  //     status: 'საშეღავათო პერიოდი იწურება 5 დღეში',
  //     checked: true,
  //     amount: 125,
  //     payDay: '2025-06-30',
  //     objectName:'toyota BB111JK'

  //   },
  //   {
  //     coverage: 'Third Party',
  //     coverageArea: 'Worldwide',
  //     currency: 'EUR',
  //     email: 'jane.smith@example.com',
  //     franchise: 'Premium',
  //     fromDate: '2025-05-15',
  //     id: 2,
  //     insurerFullName: 'Global Insure Co.',
  //     insurerFullNameEng: 'Global Insure Co.',
  //     insurerPn: '2233445566',
  //     isMultiPolicy: true,
  //     limit: 100000,
  //     phoneNumber: '+441234567890',
  //     policyNumber: 'K/PR/R/D/120622/25',
  //     policyType: 'Health',
  //     policyUrl: 'https://example.com/policies/2',
  //     policyWordingUrl: 'https://example.com/wording/2',
  //     premium: 450,
  //     productType: 2,
  //     toDate: new Date('2025-11-15'),
  //     travelerFullName: 'Jane Smith',
  //     travelerFullNameEng: 'Jane Smith',
  //     travelerPn: '1122334455',
  //     wordingName: 'Global Health Cover',
  //     currentDebt: 50,
  //     insuredName: 'John Doe',
  //     status: 'გადასახდელი',
  //     checked: true,
  //     amount: 127,
  //     payDay: '2025-06-30',
  //     objectName:'თბილისი, მთაწმინდის რაიონი, ვაშლოვანის ქ.3'
  //   },
  //   {
  //     coverage: 'Third Party',
  //     coverageArea: 'Worldwide',
  //     currency: 'EUR',
  //     email: 'jane.smith@example.com',
  //     franchise: 'Premium',
  //     fromDate: '2025-05-15',
  //     id: 3,
  //     insurerFullName: 'Global Insure Co.',
  //     insurerFullNameEng: 'Global Insure Co.',
  //     insurerPn: '2233445566',
  //     isMultiPolicy: true,
  //     limit: 100000,
  //     phoneNumber: '+441234567890',
  //     policyNumber: 'K/PR/R/D/120622/26',
  //     policyType: 'Health',
  //     policyUrl: 'https://example.com/policies/2',
  //     policyWordingUrl: 'https://example.com/wording/2',
  //     premium: 450,
  //     productType: 2,
  //     toDate: new Date('2025-11-15'),
  //     travelerFullName: 'Jane Smith',
  //     travelerFullNameEng: 'Jane Smith',
  //     travelerPn: '1122334455',
  //     wordingName: 'Global Health Cover',
  //     currentDebt: 50,
  //     insuredName: 'John Doe',
  //     status: 'გაუქმებული',
  //     checked: false,
  //     amount: 129,
  //     payDay: '2025-06-30',
  //     objectName:'პასუხისმგებლობის დაზღვევა'
  //   },
  //   {
  //     coverage: 'Third Party',
  //     coverageArea: 'Worldwide',
  //     currency: 'EUR',
  //     email: 'jane.smith@example.com',
  //     franchise: 'Premium',
  //     fromDate: '2025-05-15',
  //     id: 3,
  //     insurerFullName: 'Global Insure Co.',
  //     insurerFullNameEng: 'Global Insure Co.',
  //     insurerPn: '2233445566',
  //     isMultiPolicy: true,
  //     limit: 100000,
  //     phoneNumber: '+441234567890',
  //     policyNumber: 'K/PR/R/D/120622/26',
  //     policyType: 'Health',
  //     policyUrl: 'https://example.com/policies/2',
  //     policyWordingUrl: 'https://example.com/wording/2',
  //     premium: 450,
  //     productType: 2,
  //     toDate: new Date('2025-11-15'),
  //     travelerFullName: 'Jane Smith',
  //     travelerFullNameEng: 'Jane Smith',
  //     travelerPn: '1122334455',
  //     wordingName: 'Global Health Cover',
  //     currentDebt: 50,
  //     insuredName: 'John Doe',
  //     status: 'გაუქმებული',
  //     checked: false,
  //     amount: 129,
  //     payDay: '2025-06-30',
  //     objectName:'პასუხისმგებლობის დაზღვევა'
  //   },
  // ]

};